import { useMemo } from 'react'

//* Components
import Container from 'components/common/Container'
import Text from 'components/common/Text'
import Accordion from './Accordion'

//* Style
import LandingAccordionStyle from './style'

const LandingAccordion = ({ title, accordions, first }) => {
    //! Store accordions
    const storeAccordions = useMemo(() => {
        return accordions.map((accordion, index) => (
            <Accordion
                key={index}
                className={accordions.length === 1 ? 'one-item' : index === accordions.length - 1 ? 'last' : index === 0 ? 'first' : ''}
                title={accordion.title}
                text={accordion.description}
            />
        ))
    }, [accordions])

    return (
        <LandingAccordionStyle>
            <Container first={first} section>
                <Text className={'h3 font-ping-bolder landing-accordion-title'} text={title || 'whyChooseArmenia'} />
                {storeAccordions}
            </Container>
        </LandingAccordionStyle>
    )
}

export default LandingAccordion
